// extracted by mini-css-extract-plugin
export default {"editor":"DishesEditor_editor__3bwIp","dark":"DishesEditor_dark__mwRj7","name":"DishesEditor_name__a+xLX"};